import React from "react";
import second from "../../image/second.png";
const ETA = ({features}) => {
  return (
    <>
      <div className="md:pl-10 md:pr-10 lg:pl-14 lg:pr-12 xl:pl-44 xl:pr-44" ref={features}>
        <div className="md:flex md:mt-0 items-center justify-between">
          <div className="">
            <img className="w-full sm:w-auto" src={second} alt="" />
          </div>
          <div className="p-8 sm:p-0 text-right">
            <h4 className="mb-3 font-bold text-yellow-500">ETA's</h4>
            <h5 className="mb-6 text-3xl font-bold text-gray-700 lg:text-5xl">
              A Great Tailgate{" "}
              <span className="block mt-3">experience starts here</span>
            </h5>
            <h4 className="">
              {" "}
              No more unexpected ETA's. See everyone's location
            </h4>
            <h4>
              directly in the app for a no headache start to your adventure.
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default ETA;
